import React from "react";

const SideSpacing = props => (

<div className="hidden txtlogo text-transparent font-logo overflow-hidden
md:font-bold md:w-auto md:pin-t md:pin-l md:flex md:pr-6">
    <div className="idw"/>
</div>

);

export default SideSpacing;


// WEBPACK FOOTER //
// ./src/components/HOC/sidespacing.js